export default function Commitment() {
  return (
    <section id="commitment" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#ff8c42] font-bold text-base mb-4">湧水堂の想い</p>
          <h2 className="text-2xl lg:text-3xl font-bold text-[#1a2b4a] mb-6">
            湧水堂は<br />
            技術と価格だけでなく<br />
            <span className="text-3xl lg:text-4xl">『ホスピタリティ』</span>を<br />
            公約として掲げています
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            リフォームは、お客様の大切な住まいに入らせていただく仕事。<br />
            だからこそ、技術や価格だけでなく、<strong className="text-[#1a2b4a]">「人としての誠実さ」</strong>を何よりも大切にしています。
          </p>
        </div>

        {/* Main Content */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Left - Image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/bb46e0ed325afebce2034755c99b96ea.png"
                alt="お客様への誠実な対応"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 bg-[#ff8c42] text-white px-8 py-6 rounded-2xl shadow-xl">
              <p className="text-sm font-bold">お客様満足度</p>
              <p className="text-4xl font-bold">98.3%</p>
            </div>
          </div>

          {/* Right - Content */}
          <div className="space-y-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-[#ff8c42]">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#ff8c42]/10 rounded-full flex-shrink-0">
                  <i className="ri-heart-fill text-[#ff8c42] text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#1a2b4a] mb-2">
                    「ありがとう」が、湧水堂の原動力
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    工事が終わった後、お客様から「頼んで良かった」と言っていただける瞬間。それが、湧水堂にとって何よりの喜びです。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-[#1a2b4a]">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#1a2b4a]/10 rounded-full flex-shrink-0">
                  <i className="ri-team-fill text-[#1a2b4a] text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#1a2b4a] mb-2">
                    地域の皆様に誇れる、誠実な施工を
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    「湧水堂に頼んでよかった」という言葉が、私たちの最大の喜びです。地域の皆様に顔向けできない仕事は一切いたしません。地元で培った信頼を裏切ることなく、10年、20年先まで責任を持って皆様の住まいを見守り続けます。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-[#ff8c42]">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#ff8c42]/10 rounded-full flex-shrink-0">
                  <i className="ri-shield-check-fill text-[#ff8c42] text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#1a2b4a] mb-2">
                    技術だけでは足りない
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    どんなに技術が優れていても、お客様に不安を与えてしまっては意味がありません。だからこそ、湧水堂は「ホスピタリティ」を公約として掲げています。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Message */}
        <div className="bg-gradient-to-br from-[#1a2b4a] to-[#2a3b5a] rounded-3xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-6">
            「また頼みたい」と思っていただける<br />
            リフォーム会社を目指して
          </h3>
          <p className="text-lg text-gray-200 leading-relaxed max-w-3xl mx-auto">
            湧水堂は、一度きりの関係ではなく、<strong className="text-[#ff8c42]">「困ったときにまた頼みたい」</strong>と思っていただける存在でありたいと考えています。<br />
            そのために、技術・価格・ホスピタリティの三位一体で、お客様の期待を超えるサービスを提供し続けます。
          </p>
        </div>
      </div>
    </section>
  );
}